var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5C4.75 3.75736 5.75736 2.75 7 2.75H11.7574C12.3541 2.75 12.9264 2.98705 13.3483 3.40901L13.8787 2.87868L13.3483 3.40901L18.591 8.65165C19.0129 9.07361 19.25 9.6459 19.25 10.2426V19C19.25 20.2426 18.2426 21.25 17 21.25H7C5.75736 21.25 4.75 20.2426 4.75 19V5Z",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V8C12 9.10457 12.8954 10 14 10H19",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5142V12.5H14.2784V13.5142H12.4972V18.3182H11.2813V13.5142H9.5Z",
    fill: "#272932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFile);
export default __webpack_public_path__ + "static/media/text_file.08f3f445c4c95046630c6ee98ee402e3.svg";
export { ForwardRef as ReactComponent };